import {Component, Input, OnInit} from '@angular/core';
import {Nom035Service} from '../../../../services/nom035.service';
import {EmployeeService} from '../../../../employee.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { StationService } from '../../../../services/stations.service';
const orderBy = require('lodash.orderby');

@Component({
  selector: 'ngx-test-bullying',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
})
export class BullyingTestComponent implements OnInit {
  @Input() stationId;

  constructor(
    private employeeService: EmployeeService,
    private nom035Service: Nom035Service,
    private stationService: StationService,
    ) {
    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
    }

  questions = [];
  selectedEmployeeId = 0;
  employees = [];
  loading = false;
  ratings = {
    1: [
      { value: 0, name: 'Siempre' },
      { value: 1, name: 'Casi siempre' },
      { value: 2, name: 'Algunas veces' },
      { value: 3, name: 'Casi nunca' },
      { value: 4, name: 'Nunca' },
    ],
    2: [
      { value: 4, name: 'Siempre' },
      { value: 3, name: 'Casi siempre' },
      { value: 2, name: 'Algunas veces' },
      { value: 1, name: 'Casi nunca' },
      { value: 0, name: 'Nunca' },
    ],
  };

  async ngOnInit() {
    this.init();
  }

  init() {
    this.getEmployeesByStationId();
  }

  async getEmployeesByStationId() {
    this.loading = true;
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. Lista empleados');
    this.employees = result.data;
  }

  async getFormNom035ByEmployee() {
    if (!this.selectedEmployeeId) return;
    this.loading = true;
    const [err, response]: any = await this.nom035Service.getQuestionsByEmployeeId(this.selectedEmployeeId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. cargar cuestionario');
    if (response.data && response.data.questions) {
      this.questions = response.data.questions;
      return this.alert('Cuestionario existente', 'success', 'Se cargo cuestionario del empleado con exito');
    }
    await this.getQuestions();
  }

  async getQuestions() {
    this.loading = true;
    const [error, response]: any = await this.nom035Service.getQuestions();
    this.loading = false;
    if (error) return this.alert('Oops, intenta más tarde', 'error');
    this.questions = await orderBy(response.data, ['id'], ['asc']);
    await this.formattDataQuestions();
  }

  async formattDataQuestions() {
    for (const question of this.questions) question.response = 0;
  }

  async storeQuestionnaire() {
    this.loading = true;
    const [err] = await this.nom035Service.storeQuestionsEmployee(this.selectedEmployeeId, this.stationId, this.questions);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. Guardar cuestionario');
    this.selectedEmployeeId = 0;
    return this.alert('Cuestionario guardado con exito');
  }

  async alert(title: string = 'text', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
